import { createFileRoute } from "@tanstack/react-router";
import { NotFoundPage } from "@/components/NotFoundPage";

export const Route = createFileRoute("/404")({
  head: () => ({
    meta: [
      { title: "Page Not Found or Unavailable | Phil Carr" },
      {
        name: "description",
        content:
          "The page could not be found or accessed. Use useful links or contact Phil Carr for help with SEO, web design, hosting, or website support.",
      },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: "Page Not Found or Unavailable | Phil Carr" },
      {
        property: "og:description",
        content: "Use useful links or contact Phil Carr if a page has moved, no longer exists, or cannot be accessed.",
      },
      { property: "og:url", content: "https://www.phil-carr.co.uk/404" },
    ],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/404" }],
  }),
  component: NotFoundPage,
});
